import { VoucherFilterOptions, VoucherStatus } from 'models';
import { Wrapper, Label, TagList, Tag } from './TagFilter.styles';

interface TagFilterProps {
  options: VoucherFilterOptions[];
  onFilter: (id: VoucherStatus) => void;
}

const TagFilter = ({ options, onFilter }: TagFilterProps) => (
  <Wrapper aria-label="Tag filter">
    <Label variant="h6">Filter:</Label>
    <TagList direction="row" spacing={1}>
      {options.map(({ id, label, icon, isActive, isVisible }) => {
        if (!isVisible) {
          return null;
        }

        return (
          <Tag
            key={id}
            icon={icon}
            label={label}
            onClick={() => onFilter(id)}
            color={isActive ? 'primary' : undefined}
            aria-label="Filter tag"
          />
        );
      })}
    </TagList>
  </Wrapper>
);

export default TagFilter;
